import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { LeadTaskType } from "@/modules/lead/constants/leadTaskType"

@Serializable
export class LeadConvertModel {
  taskId: string = ""
  taskType: number = LeadTaskType.NotDefined
}
